export const getAppCheckToken = async () => null;